import ProjectSettings from './ProjectSettings';

export default ProjectSettings;
